import { User } from "oidc-client-ts";
import { doGet } from "./util/apiHelper.ts";
import { useAuthenticatedQuery } from "./util/queryHelper.ts";

export interface CalendarEvent {
  from: Date;
  to: Date;
  booked: boolean;
  title: string;
}

export interface CalendarScheduleResponse {
  calendarEvents: CalendarEvent[];
}

export interface CalendarEntry {
  from: Date;
  to: Date;
  booked: boolean;
  title?: string;
}

async function getCalendarSchedule(
  from: Date,
  to: Date,
  user: User,
  teacherId?: string,
  locationId?: string,
): Promise<CalendarEntry[]> {
  const data = await doGet<CalendarScheduleResponse>(
    `/calendar/${teacherId}`,
    user,
    {
      from: from.toISOString(),
      to: to.toISOString(),
      locationId: locationId || "",
    },
  );

  return data.calendarEvents.map((event) => ({
    from: event.from,
    to: event.to,
    booked: event.booked,
    title: event.title,
  }));
}

export function useCalendar(
  from: Date,
  to: Date,
  teacherId?: string,
  locationId?: string,
) {
  return useAuthenticatedQuery(
    [
      "calendar",
      from.toISOString().split("T")[0],
      to.toISOString().split("T")[0],
      teacherId,
      locationId,
    ],
    async (user) =>
      await getCalendarSchedule(from, to, user, teacherId, locationId),
    {
      initialData: [],
      staleTime: 0,
      enabled: !!locationId,
    },
  );
}
